import { TrackRecordBadge } from "../TrackRecordBadge";

/**
 * Uber-style big display hero.
 * - Two-column asymmetric grid on lg+ (text left, rich `rightSlot` right).
 * - Falls back to single column on <lg or when no rightSlot is provided.
 * - Eyebrow label + massive display headline + supporting subhead.
 * - Track record pill sits directly beneath the subhead.
 */
export const HeroHeader = ({ title, subtitle, eyebrow = "Top 25 daily picks", rightSlot = null }) => {
  const hasRight = Boolean(rightSlot);
  return (
    <section
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-8 lg:pt-16 lg:pb-12 nd-fade-up"
      data-testid="hero-header"
    >
      <div
        className={
          hasRight
            ? "grid grid-cols-1 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)] gap-8 lg:gap-12 items-center"
            : "flex flex-col gap-5 max-w-4xl"
        }
      >
        <div className="flex flex-col gap-5">
          <span className="eyebrow" data-testid="hero-eyebrow">{eyebrow}</span>
          <h1
            className="font-display text-[44px] sm:text-[64px] lg:text-[84px] font-bold leading-[0.95] tracking-[-0.035em] text-foreground"
            data-testid="hero-title"
          >
            {title || (
              <>
                Easy-to-Predict
                <br />
                <span className="text-primary">Top 25 Games.</span>
              </>
            )}
          </h1>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl leading-relaxed">
            {subtitle ||
              "Data-driven football betting intelligence powered by multi-source consensus, team stats and an ELO + bivariate-Poisson engine."}
          </p>
          <div className="pt-1">
            <TrackRecordBadge days={30} />
          </div>
        </div>
        {hasRight && (
          <div className="w-full nd-fade-up" data-testid="hero-right-slot">
            {rightSlot}
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroHeader;
